import React, { useState } from "react";
import {
  Tabs,
  Layout,
  Typography,
  Button,
  Dropdown,
  Menu,
  Input,
  Row,
  Spin,
} from "antd";
import {
  UserOutlined,
  BookOutlined,
  TrophyOutlined,
  TeamOutlined,
  FolderOutlined,
  EyeOutlined,
  DownOutlined,
} from "@ant-design/icons";
import WorkExperience from "./Experience/WorkExperience";
import EducationInfo from "./Education/Education";
import Competencies from "./Compotencies/Competencies";
import { theme } from "../../../utils/theme";
import PersonnelCVPage from "./CV/PersonnelCVPage";
import usePersonnelInfoService from "../../../services/usePersonnelInfoService";
import useCommonsService from "../../../services/useCommonsService";
import CVPreviewModal from "./Components/CVPreviewModal";

const { Header, Content } = Layout;
const { Title } = Typography;
const { TextArea } = Input;

const DetailedProfile = () => {
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [previewHtml, setPreviewHtml] = useState("");

  const { useGetPersonnelInfo, useGetCvPreview, useGetCvPreviewPdf } =
    usePersonnelInfoService();
  const { data: personnelInfoData, isPending: isPersonnelInfoLoading } =
    useGetPersonnelInfo();
  const { mutateAsync: getCvPreview, isPending: isCvPreviewLoading } =
    useGetCvPreview();
  const { mutateAsync: getCvPreviewPdf, isPending: isCvPreviewPdfLoading } =
    useGetCvPreviewPdf();

  if (isPersonnelInfoLoading || isCvPreviewLoading || isCvPreviewPdfLoading) {
    return <Spin fullscreen spinning={true} />;
  }

  const handleGetCvPreview = async () => {
    try {
      const response = await getCvPreview();
      setPreviewHtml(response.data);
      setIsPreviewModalOpen(true);
    } catch (error) {}
  };

  const handleDownloadPdf = async () => {
    try {
      const response = await getCvPreviewPdf();
      const pdfUrl = response.data;

      // Create a temporary anchor element
      const link = document.createElement("a");
      link.href = pdfUrl;

      // Extract filename from URL or use default name
      const fileName = "cv.pdf";
      link.download = fileName;

      // Append to document, click, and remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      // Handle error
    }
  };

  const tabItems = [
    // {
    //   label: (
    //     <span>
    //       <UserOutlined />
    //       Kişisel Bilgiler
    //     </span>
    //   ),
    //   key: "1",
    //   children: <PersonalInfo />,
    // },
    {
      label: (
        <span>
          <TeamOutlined />
          Deneyimler
        </span>
      ),
      key: "2",
      children: (
        <WorkExperience
          personnelExperience={personnelInfoData?.data?.personnelExperiences}
        />
      ),
    },
    {
      label: (
        <span>
          <BookOutlined />
          Eğitim
        </span>
      ),
      key: "3",
      children: (
        <EducationInfo
          personalEducation={personnelInfoData?.data?.personnelEducations}
        />
      ),
    },
    {
      label: (
        <span>
          <TrophyOutlined />
          Yetkinlikler
        </span>
      ),
      key: "4",
      children: <Competencies personnelInfoData={personnelInfoData.data} />,
    },
    {
      label: (
        <span>
          <FolderOutlined />
          Dosyalar
        </span>
      ),
      key: "5",
      children: <PersonnelCVPage cvUrl={personnelInfoData?.data.cvUrl} />,
    },
  ];

  return (
    <Layout
      style={{ minHeight: "100vh", background: "#fff", marginBottom: 40 }}>
      <Content>
        <div
          style={{
            background: theme.lightPrimaryColor,
            padding: "16px",
            minHeight: "350px",
            position: "relative",
          }}>
          <div style={{ maxWidth: "900px", margin: "0 auto" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "16px",
              }}></div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                padding: "10px",
              }}>
              <Title
                level={2}
                style={{
                  fontFamily: "Abel, sans-serif",
                  fontWeight: 600,
                  color: "white",
                }}>
                Kişisel Bilgilerini Düzenle
              </Title>
            </div>
          </div>
        </div>
        <div
          style={{
            maxWidth: "900px",
            margin: "-200px auto 0",
            background: "white",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            padding: "16px",
            position: "relative",
            zIndex: 1,
          }}>
          <Row justify="space-between" style={{ marginBottom: 10 }}>
            <Button
              onClick={() => {
                handleGetCvPreview();
              }}
              icon={<EyeOutlined />}
              style={{ borderRadius: "20px" }}>
              CV Görüntüle
            </Button>
          </Row>

          <Tabs
            defaultActiveKey="1"
            type="card"
            items={tabItems}
            style={{ marginBottom: "16px" }}
          />
        </div>
        <CVPreviewModal
          isOpen={isPreviewModalOpen}
          onClose={() => setIsPreviewModalOpen(false)}
          htmlContent={previewHtml}
          onDownload={handleDownloadPdf}
          isDownloading={isCvPreviewPdfLoading}
        />
      </Content>
    </Layout>
  );
};

export default DetailedProfile;
